import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import ContactsUs from '@/components/Base/StaticContent/ContactUs';

import { StaticContentText, StaticContentTitle } from '../StaticContent.styles';

import { Number, Step, Wrapper } from './HowToIssueBusinessLoan.styles';

export function HowToIssueBusinessLoan({ params = {} }) {
  const { formatMessage } = useIntl();
  const isLandingPage = params?.landing;

  return (
    <Wrapper id="howToIssueBusinessLoan" className="sections">
      <StaticContentTitle as="h2">
        {formatMessage({
          id: 'staticContent.anchorLinks.map.title.howToIssueBusinessLoan',
        })}
      </StaticContentTitle>

      {Array.from({ length: 6 }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Step key={index}>
          <Number>{index + 1}</Number>

          <StaticContentText>
            {formatMessage({
              id: `staticContent.howToIssueBusinessLoan.step.${index}`,
            })}
          </StaticContentText>
        </Step>
      ))}

      {isLandingPage && <ContactsUs />}
    </Wrapper>
  );
}

HowToIssueBusinessLoan.propTypes = {
  params: PropTypes.object,
};

export default HowToIssueBusinessLoan;
